<template>
  <div class="suppliers-actions">
    <div class="listing-title">{{ $t(titleAllOrFiltered) }}</div>
    <div class="search">
      <tol-type-ahead
        :display-value="supplierSearchParam"
        :search-params="{
          url: '/suppliers/list',
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: supplierRecordsPerPage,
            offset: supplierRecordsOffset,
            sortBy: supplierSortField,
            sortDirection: supplierSortDirection
          }
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
        @search-in-progress="onSearchInProgress($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="action-btns">
      <router-link to="/suppliers/create">
        <TolAltButton icon-name="plus" :label="$t('suppliers.listing.actions.new')" />
      </router-link>

      <TolAltButton
        v-click-outside="() => (displayExportOptions = false)"
        icon-name="file-excel"
        :label="$t('suppliers.listing.actions.exportToExcel')"
        @click="displayExportOptions = !displayExportOptions"
      />

      <Dropdown
        v-if="displayExportOptions"
        :menu-items="[
          { icon: '', label: $t('suppliers.listing.actions.exportAll') },
          { icon: '', label: $t('suppliers.listing.actions.exportPage') }
        ]"
        class="dropdown-menu-right dropdown-display"
        @optionClicked="onMenuOptionSelected($event)"
      />
    </div>
  </div>
</template>
<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';

import {
  SuppliersListingActions,
  SuppliersListingGetters
} from '@/app/features/suppliers/features/suppliers-listing/suppliers-listing.keys';
import Dropdown from '@/app/components/Dropdown';
import vClickOutside from 'v-click-outside';
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    TolAltButton,
    Dropdown,
    TolTypeAhead
  },
  props: {
    titleAllOrFiltered: {
      type: String,
      default: 'suppliers.listing.all'
    }
  },
  data() {
    return {
      displayExportOptions: false
    };
  },
  computed: {
    supplierSearchParam() {
      return this.$store.getters[SuppliersListingGetters.SupplierSearchParam];
    },
    supplierRecordsPerPage() {
      return this.$store.getters[SuppliersListingGetters.SuppliersPerPage];
    },
    supplierRecordsOffset() {
      return this.$store.getters[SuppliersListingGetters.SupplierListingOffset];
    },
    supplierSortField() {
      return this.$store.getters[SuppliersListingGetters.SortBy];
    },
    supplierSortDirection() {
      return this.$store.getters[SuppliersListingGetters.SortDirection];
    }
  },
  methods: {
    exportAsExcel() {
      this.$store.dispatch(SuppliersListingActions.DownloadSuppliersListAsExcel);
    },
    onMenuOptionSelected(event) {
      this.displayExportOptions = false;
      this.$store.dispatch(SuppliersListingActions.DownloadSuppliersListAsExcel, event.menuOption);
    },
    onFiltered(results) {
      this.$store.dispatch(SuppliersListingActions.UpdateSuppliersList, results);
    },
    onSearchInProgress(searchFlag) {
      this.$emit('load-spinner', searchFlag);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.suppliers-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
  align-items: center;

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }
  .action-btns {
    display: flex;
    position: relative;
    margin-left: auto;

    justify-content: flex-end;
    flex-basis: 25%;
    .supplier-action {
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 0px 0px 0px 40px;

      font-size: 1.5em;
      margin-right: 20px;
      color: $white;
      border-radius: 100%;
      background-color: $light-grey-2;
      &:hover {
        background-color: $secondary-green;
      }
    }
    a,
    a.wrapper {
      text-decoration: none;
      color: inherit;
    }
    .wrapper {
      margin-right: 3px;
    }
  }
  .dropdown-display {
    border-right: 1px solid $row-border;
    border-left: 1px solid $row-border;
    border-bottom: 1px solid $row-border;
    font-weight: bold;
  }

  .search {
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
    }
  }
}
</style>
